import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from "@angular/core";

interface SharedClassroomNotificationsConfig {
    showSnackbarOnJoinLessonFailure: boolean;
}

export const SHARED_CLASSROOM_NOTIFICATIONS_CONFIG = new InjectionToken<SharedClassroomNotificationsConfig>('SHARED_CLASSROOM_NOTIFICATIONS_CONFIG');

export function provideSharedClassroomNotificationsConfig(config: SharedClassroomNotificationsConfig): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: SHARED_CLASSROOM_NOTIFICATIONS_CONFIG, useValue: config }
    ]);
};
